import React from 'react';

interface ErrorStateProps {
  error: string;
  onRetry: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center gap-2 w-full">
      <p className="text-sm font-medium text-red-400 font-sans">{error}</p>
      <button onClick={onRetry} className="text-xs text-cat-accent uppercase font-bold hover:underline">
        Retry Connection ↻
      </button>
    </div>
  );
};